<mat-form-field
  [formGroup]="formGroup"
  [subscriptSizing]="subscriptSizing"
  [floatLabel]="placeholder ? 'always' : 'auto'"
  appearance="outline"
>
  <mat-icon matPrefix>search</mat-icon>

  @if(label) {
  <mat-label>{{ label }}</mat-label>
  }

  <input [formControlName]="controlName" hidden />

  <input
    matInput
    type="text"
    [placeholder]="placeholder"
    [formControl]="searchCtrl"
    (ngModelChange)="onChangeInput($event)"
    [matAutocomplete]="auto"
    [required]="isRequired(controlName)"
  />

  <mat-icon matSuffix>arrow_drop_down</mat-icon>

  <mat-autocomplete
    #auto="matAutocomplete"
    [displayWith]="displayFn.bind(this)"
    (optionSelected)="selected($event)"
  >
    <!-- <cdk-virtual-scroll-viewport appendOnly itemSize="50" class="scroll-viewport">
      <mat-option
        class="scroll-viewport-item"
        *cdkVirtualFor="let value of filteredValues()"
        [value]="value[idField]"
      >
        {{ value[viewField] }}
      </mat-option>
    </cdk-virtual-scroll-viewport> -->
    @for (value of filteredValues(); track value) {
    <mat-option [value]="value[idField]">{{ value[viewField] }}</mat-option>
    }
  </mat-autocomplete>

  @if (hasError) {
  <mat-error>{{ errorMessage }}</mat-error>
  }
</mat-form-field>
